module.exports = __webpack_public_path__ + "img/phone_repair.26e90380.png";